import { ReactComponent as OptionsIcon } from '@assets/icons/options.svg';
import { styled } from '@/stitches.config';

export const OptionsIconStyled = styled(OptionsIcon, {});
